export const DOCUMENT_TYPE = {
  IDENTIFICATION: 'Identification',
  CERTIFICATION: 'Certification',
  CONTRACT: 'Contract',
  FIRST_AID: 'First Aid'
};
